import { Link } from "react-router-dom";
import type { Category } from "@/types/content";

export default function CategoryGrid({ categories }: { categories: Category[] }) {
  return (
    <section id="categories" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="max-w-2xl">
          <span className="font-label text-xs tracking-[0.28em] text-primary-600">CATEGORIES</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            爆料分类
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            六个常驻栏目，覆盖吃瓜用户最常关注的领域。每个栏目都由固定编辑维护，保证内容的连续性。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/rank?category=${cat.slug}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 hover:bg-background-50"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <div className="mt-4 flex items-center justify-between">
                <h3 className="font-heading text-lg font-bold text-foreground-950">{cat.name}</h3>
                <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-800">
                  {cat.count} 条
                </span>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
              <span className="mt-4 flex items-center gap-1 text-xs text-foreground-500 transition-colors group-hover:text-primary-600">
                进入栏目 <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}